import React from "react";
import TextInput from "../inputs/TextInput";

const Phone = ({
	register,
	error,
	placeholder = "Enter your phone number",
	required = false,
	className = "",
	id,
}) => {
	return (
		<TextInput
			label=""
			placeholder={placeholder}
			required={required}
			error={error}
			hideLabel={true}
			{...register(id, {
				required: required ? "Phone number is required" : false,
				pattern: {
					value:
						/^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/,
					message: "Please enter a valid phone number",
				},
			})}
			name={id}
		/>
	);
};

export default Phone;
